import {get} from '@/ehf/ehfApi.service'

export const fetchEhfJSON = async (invoiceUuid: string) => {
    return await get(`/v2/${invoiceUuid}`, {}, {'Accept': 'application/json'})
}

export const fetchEhfXML = async (invoiceUuid: string) => {
    return await get(`/v2/${invoiceUuid}`, {}, {'Accept': 'application/xml'})
}